import React from 'react';
import { CrownIcon } from '@phosphor-icons/react';
import ModalCloseButton from '../components/generic/ModalCloseButton';

const PremiumFeatureModal = ({ isOpen, onClose, title, body, desc, ctaText, onCtaClick }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative bg-[var(--q3-surface-default)] rounded-2xl p-6 max-w-md w-full mx-4 border border-[var(--q3-stroke-normal)] shadow-2xl"
      >
        <ModalCloseButton onClick={onClose} />

        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <CrownIcon size={32} weight="fill" />
          </div>

          <h2 className="text-2xl font-bold text-[var(--q3-neutral-default)] mb-3">{title}</h2>
          <p className="text-base text-[var(--q3-neutral-default)] mb-4 leading-relaxed">{body}</p>
          <div className="text-sm text-[var(--q3-neutral-light)] italic">{desc}</div>
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button
            onClick={onCtaClick}
            className="w-full border hover:scale-105 transition-all cursor-pointer duration-300 text-[var(--q3-neutral-default)] font-semibold py-3 px-6 rounded-lg hover:opacity-90 "
          >
            {ctaText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumFeatureModal;
